import { FolderOpen } from "lucide-react";
import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "components/common/dropdown/DropDownV2";
import { WORKSPACE_PRODUCT_NAV } from "pages/settings/workspace/WorkspaceSettings.sections";
import { DropdownSectionLabel } from "../DropdownSectionLabel";
import { WorkspaceProfileInfo } from "../WorkspaceProfileInfo";
import { WorkspaceSettingsQuickLinks } from "../WorkspaceSettingsQuickLinks";
import { WorkspaceSwitcherList } from "../WorkspaceSwitcherList";
import { WorkspaceSettingsShellMenuProps } from "./WorkspaceSettingsShellMenu.types";

export const WorkspaceSettingsShellMenu = ({
  activeWorkspaceId,
  currentWorkspaceName,
  currentWorkspaceRole,
  currentWorkspaceImagePath,
  settingsCategories,
  activePathname,
  workspaces,
  onAllProjects,
  onNavigateSettings,
  onSwitchWorkspace,
  onClose,
}: WorkspaceSettingsShellMenuProps) => {
  const showWorkspaceSwitcher = workspaces.length > 1;

  return (
    <>
      {activeWorkspaceId ? (
        <>
          <DropdownMenuLabel className="p-0 font-normal">
            <WorkspaceProfileInfo
              workspaceId={activeWorkspaceId}
              workspaceName={currentWorkspaceName}
              role={currentWorkspaceRole}
              imagePath={currentWorkspaceImagePath}
            />
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
        </>
      ) : null}

      <DropdownMenuGroup>
        <DropdownMenuItem
          onClick={() => {
            onAllProjects();
            onClose();
          }}
        >
          <FolderOpen className="h-4 w-4 shrink-0 text-muted-foreground" />
          <span className="flex-1">{WORKSPACE_PRODUCT_NAV.title}</span>
        </DropdownMenuItem>
      </DropdownMenuGroup>

      {settingsCategories.length > 0 && activeWorkspaceId ? (
        <>
          <DropdownMenuSeparator />
          <WorkspaceSettingsQuickLinks
            categories={settingsCategories}
            activePathname={activePathname}
            workspaceId={activeWorkspaceId}
            onNavigate={onNavigateSettings}
            onClose={onClose}
          />
        </>
      ) : null}

      {showWorkspaceSwitcher ? (
        <>
          <DropdownMenuSeparator />
          <DropdownSectionLabel>Switch workspace</DropdownSectionLabel>
          <WorkspaceSwitcherList
            workspaces={workspaces}
            activeWorkspaceId={activeWorkspaceId}
            onSwitchWorkspace={onSwitchWorkspace}
            onClose={onClose}
          />
        </>
      ) : null}
    </>
  );
};
